module.exports = __webpack_public_path__ + "static/andy-87bd6c3e02ee0a69f7532b3426cd336f.jpg";